import { fmtKm, fmtPct } from "@/lib/wholesale-format";

export type Totals = { subtotal: number; discountTotal: number; total: number; net: number; vat: number };

/** Zbirovi narudžbe; Osnovica i PDV se prikazuju samo kad je stopa poznata. */
export function TotalsPanel({ totals, vatRate }: { totals: Totals; vatRate?: number }) {
  return (
    <div className="flex flex-col gap-1 text-xs ml-auto w-full sm:w-72">
      <div className="flex justify-between">
        <span className="text-muted-foreground">Bez rabata</span>
        <span className="tabular-nums">{fmtKm(totals.subtotal)}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-muted-foreground">Rabat</span>
        <span className="tabular-nums">− {fmtKm(totals.discountTotal)}</span>
      </div>
      <div className="flex justify-between font-medium border-t pt-1">
        <span>Ukupno</span>
        <span className="tabular-nums">{fmtKm(totals.total)}</span>
      </div>
      {vatRate !== undefined && (
        <>
          <div className="flex justify-between text-muted-foreground">
            <span>Osnovica</span>
            <span className="tabular-nums">{fmtKm(totals.net)}</span>
          </div>
          <div className="flex justify-between text-muted-foreground">
            <span>PDV {fmtPct(vatRate)}</span>
            <span className="tabular-nums">{fmtKm(totals.vat)}</span>
          </div>
        </>
      )}
    </div>
  );
}
